import React, { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { usePinterestBoard } from './PinterestBoard.hook'
import { QuizQuestionWrapper } from '../../components'
import { QuizType } from 'src/pages/shared'
import { LoadingSpinner } from 'src/common/components/loading/LoadingSpinner'
import '../style.scss'

export const PinterestBoard = () => {
  const location = useLocation()
  const query = useMemo(() => {
    return new URLSearchParams(location.search)
  }, [location.search])
  const { loading, boards, handleNext, handleBack, handleOauthCode } = usePinterestBoard()

  useEffect(() => {
    const code = query.get('code')
    if (code && !boards.length) {
      console.log('code', code)
      handleOauthCode(code)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [boards.length, query])

  return (
    <>
      <QuizQuestionWrapper
        titleStep="Getting Started"
        title="Choose a board to get started"
        subtitle="You can link a new board at any time."
        backAction={{
          onAction: handleBack,
        }}
        nextAction={{
          onAction: handleNext,
        }}
        step={2}
        total={7}
        className="pinterest-flow pinterest-boards request-a-proposal"
        quizType={QuizType.PINTEREST}
      >
        <div className="request-a-proposal-wrapper pinterest-boards-content">
          <div className="list-boards">
            {!loading ? (
              <>
                {boards.map((board) => (
                  <div key={board.id} className="board-item">
                    <a href={`/import-pins/${board.id}`} className="board-item-link">
                      <div className="board-images">
                        <div className="image">
                          <img src={board.media.imageCoverUrl} alt={board.name} />
                        </div>
                        {(board.media.pinThumbnailUrls || []).slice(0, 2).map((url, index) => (
                          <div className="image" key={index}>
                            <img key={index} src={url} alt={board.name} />
                          </div>
                        ))}
                      </div>
                      <div className="board-info">
                        <div className="board-title">{board.name}</div>
                        <div className="board-pin-count">{board.pinCount} pins</div>
                      </div>
                    </a>
                  </div>
                ))}
              </>
            ) : (
              <div className="loading-container">
                <LoadingSpinner size="sm" />
              </div>
            )}
          </div>
        </div>
      </QuizQuestionWrapper>
    </>
  )
}
